<template>
  <div :class="$style.container">
    <button class="btn" @click="endCall">End Call</button>
  </div>
</template>

<script>
  import EventBus from '@/lib/event-bus'

  export default {
    methods: {
      endCall () {
        EventBus.$emit('LEAVE_CONFERENCE_CALL')
      }
    }
  }
</script>

<style module lang="less" src="./end-call-button.less"></style>



// WEBPACK FOOTER //
// end-call-button.vue?402fef98